/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_Linux_TitleInputs */

const en_fc_home_platforms_linux_title = /** @type {(inputs: Fc_Home_Platforms_Linux_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft for Linux`)
};

/**
* | output |
* | --- |
* | "FilmCraft for Linux" |
*
* @param {Fc_Home_Platforms_Linux_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_linux_title = /** @type {((inputs?: Fc_Home_Platforms_Linux_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_Linux_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_linux_title(inputs)
});
export { fc_home_platforms_linux_title as "fc.home.platforms.linux.title" }